import { render } from "./AccountDisabledMessage.vue?vue&type=template&id=627a617a&scoped=true"
import script from "./AccountDisabledMessage.vue?vue&type=script&lang=js"
export * from "./AccountDisabledMessage.vue?vue&type=script&lang=js"

import "./AccountDisabledMessage.vue?vue&type=style&index=0&id=627a617a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627a617a"]])

export default __exports__